export default __webpack_public_path__ + "static/media/TK.67a6414c.svg";